export default __webpack_public_path__ + "static/media/CSW(175of1322)_tn.578d4606.jpg";